module.exports = __webpack_public_path__ + "img/network.926d074b.png";